module.exports = window["ReactRouterDOM"];